import {Component, Input, OnInit} from '@angular/core';
import {CheckboxCustomEvent, ModalController} from '@ionic/angular';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {CommonUtils} from "../../utils/common";
import {Client} from "../../models/client.model";
import {mobilePhoneNumberValidator, noWhitespaceValidator} from "../../utils/form-validators";
import {ClientsService} from "../../providers/clients.service";
import {Partner} from "../../models/partner.model";
import {ReferralsService} from "../../providers/referrals.service";
import {AppStateService} from "../../providers/app-state.service";

@Component({
  selector: 'app-become-ambasador.modal',
  templateUrl: './become-ambasador.modal.component.html',
  styleUrls: ['./become-ambasador.modal.component.scss'],
})
export class BecomeAmbasadorModalComponent implements OnInit {
  @Input() title: string;
  @Input() client: Client;
  terms: string;

  ambasadorGroup: FormGroup;
  showForm: boolean = false;
  private hasUnsavedChanges: boolean;
  businessType: number;
  private accepted: boolean = false;
  isBusy:  boolean;
  constructor(private modalController: ModalController,
              private commonUtils: CommonUtils,
              private formBuilder: FormBuilder,
              private clientService: ClientsService,
              private referralsService: ReferralsService,
              private appStateService: AppStateService) { }

  async ngOnInit() {
    console.log(this.client)
     this.businessType = this.client.businessType;
      this.ambasadorGroup = this.formBuilder.group({
        name: [this.client.name, [Validators.required, noWhitespaceValidator]],
        email: [this.client.email, [Validators.email, Validators.required, noWhitespaceValidator]],
        phone: [this.client.phone, [Validators.required, mobilePhoneNumberValidator, noWhitespaceValidator]],
        taxId: [this.client.taxId, [Validators.required, noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]],
        regon: [this.client.regon, [Validators.required, noWhitespaceValidator, Validators.minLength(9), Validators.maxLength(9)]],
        streetWithNumber: [this.client.streetWithNumber, [Validators.required, noWhitespaceValidator]],
        city: [this.client.city, [Validators.required, noWhitespaceValidator]],
        postalCode: [this.client.postalCode, [Validators.required, noWhitespaceValidator]],
      });
      this.showForm = true;

      if (this.isKrsNeeded()) {
        this.ambasadorGroup.addControl('krs', new FormControl(this.client.krs, [Validators.required, noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]));
      }

  }

  onCancelEdit() {
    this.modalController.dismiss(null);
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
    }
  }

  onShowTerms() {
    this.appStateService.updateIsBusySubject(true);
    this.referralsService.getAmbassadorTerms().subscribe(terms => {
      this.appStateService.updateIsBusySubject(false);
      if (terms){
        this.terms = terms;
      } else {
        this.commonUtils.presentAlertToast('Nie można pobrać regulaminu');
      }
    }, error => {
      this.appStateService.updateIsBusySubject(false);
      this.commonUtils.presentAlertToast('Nie można pobrać regulaminu')
    });
  }

  onSubmit() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz dołączyć do programu Ambasador?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      let partnerObj: Partner = this.commonUtils.formGroupValuesToObject<Partner>(new Partner(), this.ambasadorGroup);

      console.log(partnerObj);
      partnerObj.type = 'PARTNER';
      partnerObj.appPartnerPageTitle = 'AMBASSADOR';
      partnerObj.appPartnerPageContent = 'AMBASSADOR';
      partnerObj.termsOfServicePageContent = 'AMBASSADOR';
      partnerObj.businessType = this.businessType;

      this.appStateService.updateIsBusySubject(true);
      this.referralsService.addPartner(partnerObj).subscribe(e => {
        this.appStateService.updateIsBusySubject(false);
        if (e) {
          this.modalController.dismiss(e.uuid)
        } else {
          this.commonUtils.presentAlertToast('Wystąpil błąd podczas tworzenia konta Amasador');
        }}, error => {
        this.appStateService.updateIsBusySubject(false);
        this.commonUtils.presentAlertToast('Wystąpil błąd podczas tworzenia konta Amasador');
      });
    }, () => {
    });

  }

  isFormFieldInvalid(group: FormGroup, fieldName: string, errorType: string) {
    return this.commonUtils.isFormFieldInvalid(group, fieldName, errorType);
  }

  onToggleAccept($event: CheckboxCustomEvent) {

    this.accepted = $event.detail.checked;
    console.log(this.accepted)
    console.log(this.ambasadorGroup)
  }

  isKrsNeeded() {
    return this.businessType > 3;
  }

  selectBusinessType($event) {
    if (this.isKrsNeeded()) {
      this.ambasadorGroup.addControl('krs', new FormControl(this.client.krs, [Validators.required, noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]));
    } else {
      this.ambasadorGroup.removeControl('krs');
    }
  }

  closeToa() {
    this.terms = null;
  }
}
